module.exports = "<div class=\"image-wrap\">\n    <!-- image -->\n    <image-quiz\n        [images]=\"slide.images\"\n        [nextText]=\"'Start Quiz'\">\n    </image-quiz>\n</div>\n\n<!-- content -->\n<p *ngFor=\"let p of slide.content\" [innerHtml]=\"p.text\"></p>"


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/preview/parts/intro-quiz.component.html
// module id = ../../../../../src/swarm/src/app/slideshow/tabs/preview/parts/intro-quiz.component.html
// module chunks = main